import type { IGetCitiesResponse } from './models';

import { KEGatewayClient } from '../KEGatewayClient';

export class _CityClient extends KEGatewayClient {
  public async updateCities() {
    return this.get<IGetCitiesResponse>('main/cities');
  }
}

export const CityClient = new _CityClient();
